import TextField from "@mui/material/TextField"
import { ICompanyGroup } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate/src/components/forms"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../apiClient/axios"
import { CompaniesGroupsApiClient } from "../../apiClient/companiesGroups"
import { DEFAULTGAP } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"

export const CompanyGroupComponent = (props: {
  id?: number,
}) => {
  const [data, setData] = useState<ICompanyGroup>()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (saving) return
    setSaving(true)
    try {
      if (data) {
        const response =
          data.id ? await new CompaniesGroupsApiClient(axios).put({ data }) : await new CompaniesGroupsApiClient(axios).post({ data })
        if (response.success) {
          if (response.data?.id)
            data.id = response.data?.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  const getData = async () => {
    try {
      const response = await new CompaniesGroupsApiClient(axios).get({
        where: {
          id: Number(props.id)
        },
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        setData(response.data.payload[0])
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
  }

  useEffect(() => {
    if (props.id)
      getData()
    else
      setData({
        id: 0,
        name: '',
      })
  }, [])

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label={"Nome do grupo"}
          onChange={(e) => setData({
            ...data,
            name: e.target.value
          } as ICompanyGroup)}
        />
      </FormItemStyled>
    </FormStyled>

    <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={save} />

  </>
}